var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGatePark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.586 8.027q.108.45-.126.847a1.12 1.12 0 0 1-.685.522l-7.242 1.946-3.982 1.045-1.19.36-1.98-3.369 1.098-.288 1.477 1.117 3.73-.973-3.099-5.387 1.441-.396 5.17 4.828 4.019-1.063q.45-.126.855.118.406.243.514.693M2.885 15.036H17.17v1.513H2.885z"
})));
export default SvgGatePark;